// this gets updated automatically
export const version = '2.6.1-0';
